import { render, staticRenderFns } from "./RegionSelect.vue?vue&type=template&id=6f9bdc58&scoped=true&"
import script from "./RegionSelect.vue?vue&type=script&lang=js&"
export * from "./RegionSelect.vue?vue&type=script&lang=js&"
import style0 from "./RegionSelect.vue?vue&type=style&index=0&id=6f9bdc58&prod&lang=scss&scoped=true&"
import style1 from "./RegionSelect.vue?vue&type=style&index=1&id=6f9bdc58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9bdc58",
  null
  
)

export default component.exports